import {
  ADD_CATEGORY_REQUEST,
  ADD_CATEGORY_SUCCESS,
  ADD_CATEGORY_FAILURE,
  UPDATE_CATEGORY_REQUEST,
  UPDATE_CATEGORY_SUCCESS,
  UPDATE_CATEGORY_FAILURE,
  DELETE_CATEGORY_REQUEST,
  DELETE_CATEGORY_SUCCESS,
  DELETE_CATEGORY_FAILURE,
  GET_CATEGORY_REQUEST,
  GET_CATEGORY_SUCCESS,
  GET_CATEGORY_FAILURE,
} from "../constants/categoryConstant";

const categoryInitialState = {
  category: null,
  categoryList: [],
  loading: false,
  error: null,
};

export const categoryReducer = (state = categoryInitialState, action) => {
  switch (action.type) {
    case ADD_CATEGORY_REQUEST:
      return { ...state, loading: true, error: null };
    case ADD_CATEGORY_SUCCESS:
      return { ...state, loading: false, package: action.payload };
    case ADD_CATEGORY_FAILURE:
      return { ...state, loading: false, error: action.payload };
    case UPDATE_CATEGORY_REQUEST:
      return { ...state, loading: true, error: null };
    case UPDATE_CATEGORY_SUCCESS:
      return { ...state, loading: false, package: action.payload };
    case UPDATE_CATEGORY_FAILURE:
      return { ...state, loading: false, error: action.payload };
    case DELETE_CATEGORY_REQUEST:
      return { ...state, loading: true, error: null };
    case DELETE_CATEGORY_SUCCESS:
      return { ...state, loading: false, package: action.payload };
    case DELETE_CATEGORY_FAILURE:
      return { ...state, loading: false, error: action.payload };
    case GET_CATEGORY_REQUEST:
      return { ...state, loading: true, error: null };
    case GET_CATEGORY_SUCCESS:
      return { ...state, loading: false, package: action.payload };
    case GET_CATEGORY_FAILURE:
      return { ...state, loading: false, error: action.payload };
    default:
      return state;
  }
};
